const getSessionStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

const getLocalStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

const readAuthValue = (key) => {
  const sessionStorage = getSessionStorage();
  const localStorage = getLocalStorage();
  return sessionStorage?.getItem(key) || localStorage?.getItem(key) || null;
};

const writeAuthValue = (key, value) => {
  const sessionStorage = getSessionStorage();
  const localStorage = getLocalStorage();
  if (sessionStorage) {
    sessionStorage.setItem(key, value);
  } else if (localStorage) {
    localStorage.setItem(key, value);
  }
  if (localStorage) {
    localStorage.removeItem(key);
  }
};

const removeAuthValue = (key) => {
  const sessionStorage = getSessionStorage();
  const localStorage = getLocalStorage();
  sessionStorage?.removeItem(key);
  localStorage?.removeItem(key);
};

const ONBOARDING_PROMPT_KEY = 'post_login_feature_prompt';

const writeSessionFlag = (key, value) => {
  const sessionStorage = getSessionStorage();
  const localStorage = getLocalStorage();
  if (sessionStorage) {
    sessionStorage.setItem(key, value);
  } else if (localStorage) {
    localStorage.setItem(key, value);
  }
};

const dispatchAuthChange = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('auth-change'));
  }
};

export const getToken = () => readAuthValue('authToken');

export const getUser = () => {
  const user = readAuthValue('user');
  if (!user) return null;
  try {
    return JSON.parse(user);
  } catch {
    return null;
  }
};

export const getTenant = () => readAuthValue('tenant');

export const setAuth = (token, user, tenant) => {
  writeAuthValue('authToken', token);
  writeAuthValue('user', JSON.stringify(user));
  if (tenant) {
    writeAuthValue('tenant', tenant);
  }
  dispatchAuthChange();
};

export const updateAuthToken = (token, tenant) => {
  if (!token) return;
  writeAuthValue('authToken', token);
  if (tenant) {
    writeAuthValue('tenant', tenant);
  }
  dispatchAuthChange();
};

export const markPostLoginFeaturePromptPending = () => {
  writeSessionFlag(ONBOARDING_PROMPT_KEY, '1');
};

export const isPostLoginFeaturePromptPending = () => readAuthValue(ONBOARDING_PROMPT_KEY) === '1';

export const clearPostLoginFeaturePromptPending = () => {
  removeAuthValue(ONBOARDING_PROMPT_KEY);
};

export const clearAuth = () => {
  removeAuthValue('authToken');
  removeAuthValue('user');
  removeAuthValue('tenant');
  removeAuthValue(ONBOARDING_PROMPT_KEY);
  dispatchAuthChange();

  // Clear all app caches on logout
  const cachePrefix = 'app_cache_';
  const localStorage = getLocalStorage();
  const sessionStorage = getSessionStorage();
  [localStorage, sessionStorage].forEach((storage) => {
    if (!storage) return;
    const keys = Object.keys(storage);
    keys.forEach((key) => {
      if (key.startsWith(cachePrefix)) {
        storage.removeItem(key);
      }
    });
  });
};

export const isAuthenticated = () => {
  const token = getToken();
  return typeof token === 'string' && token.trim().length > 0;
};
